<template>
  <div class="container-cental">
    <h1 class="mt-5 mb-5">
      {{ type == "create" ? "AGREGAR" : "EDITAR" }} SUBCATEGORIAS
    </h1>
    <b-form ref="formAdd" @reset="onReset">
      <div class="row p-3 mb-5">
        <!-- selector de categorias -->
        <b-form-group
          id="categoriaId"
          label="Categoría*"
          label-for="categoriaId"
          class="col-md-6"
        >
          <b-form-select
            id="categoriaId"
            v-model="form.categoria_id"
            :options="categorias"
            ref="categoriaId"
            :state="categoriaIdState"
            required
          ></b-form-select>
        </b-form-group>

        <!-- nombre -->
        <b-form-group
          id="nombre"
          label="Nombre*"
          label-for="nombre"
          class="col-md-6"
        >
          <b-form-input
            id="nombre"
            v-model.trim="form.nombre"
            type="text"
            placeholder="Nombre de la subcategoría"
            ref="nombre"
            :state="nombreState"
            required
          ></b-form-input>
        </b-form-group>
        <!-- descripcion -->
        <b-form-group
          id="descripcion*"
          label="Descripción"
          label-for="descripcion"
          class="col-md-6"
        >
          <b-form-input
            id="descripcion"
            v-model.trim="form.descripcion"
            type="text"
            placeholder="De que trata la subcategoria"
            ref="descripcion"
            :state="descripcionState"
            required
          ></b-form-input>
        </b-form-group>
        <!-- input image1 -->
        <b-form-group
          label="Imagen"
          :class="type == 'edit' && !imagenTocada ? 'col-md-4' : 'col-md-6'"
        >
          <b-form-file
            v-model="imagen"
            ref="imagen"
            :state="imagenState"
            placeholder="Imagen no mayor a 2mb"
            drop-placeholder="Sueltala aqui..."
            accept=".jpg, .png, .jpeg"
            required
          ></b-form-file>
        </b-form-group>
        <div class="col-md-2" v-if="type == 'edit' && !imagenTocada && form.imagen">
          <img
            :src="`${urlImagesSubcategorias}${form.imagen}`"
            alt="imagen subcategoría"
            height="100"
          />
        </div>
        <!-- disponible -->
        <b-form-group label="Disponible" class="col-md-6">
          <b-form-radio-group
            v-model="form.disponible"
            :options="optionsDisponible"
            class="mb-3"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <b-button variant="primary" @click="handleSubmit">Aceptar</b-button>
      <b-button
        variant="danger"
        class="ml-3"
        @click="$router.push({ name: 'SubcategoriasList' })"
        >Cancelar</b-button
      >
    </b-form>
  </div>
</template>

<script>
import SubcategoriasService from "@/services/subcategorias.service";
import CategoriasService from "@/services/categorias.service";
import EventBus from "@/services/eventBus.js";
export default {
  name: "SubCategoriasProcessAdmin",
  data() {
    return {
      categoriasService: null,
      subcategoriasService: null,
      form: {
        categoria_id: null,
        nombre: null,
        descripcion: null,
        disponible: 2,
      },
      imagen: null,
      nombreState: null,
      descripcionState: null,
      imagenState: null,
      imagenTocada: false,
      categoriaIdState: null,
      optionsDisponible: [
        { item: 1, name: "SI" },
        { item: 2, name: "NO" },
      ],
      categorias: [{ text: "Selecciona uno", value: null }],
      type: "create",
      urlImagesSubcategorias: process.env.VUE_APP_API_IMAGES_SUBCATEGORIAS,
    };
  },
  created() {
    this.categoriasService = new CategoriasService();
    this.subcategoriasService = new SubcategoriasService();
    this.$route.params.id ? (this.type = "edit") : (this.type = "create");
  },
  mounted() {
    this.recoveryCategorias();
    if (this.type == "edit") {
      this.recoveryDataRegister();
    }
  },
  methods: {
    recoveryCategorias() {
      this.categoriasService
        .getAll()
        .then((result) => {
          this.categorias = this.categorias.concat(
            result.data.data.map((item) => {
              return { text: item.nombre, value: item.id };
            })
          );
        })
        .catch(() => {
          this.loadingData = false;
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al recuperar listado de categorías",
          });
        });
    },
    handleSubmit() {
      if (!this.validation()) {
        EventBus.$emit("MOSTRAR_TOAST", {
          title: "Error",
          variant: "warning",
          message: "Debes completar los campos obligatorios",
        });
        return false
      }
      if (this.type === "create") {
        this.createRegister();
      } else {
        this.editRegister();
      }
    },
    recoveryDataRegister() {
      this.subcategoriasService
        .getById(this.$route.params.id)
        .then((result) => {
          if(result.data.data){
            this.form = { ...result.data.data };
          }else{
            this.$router.push({name:'SubproductosList'})
          }          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createRegister() {
      this.inProcess = true;
      let formData = new FormData();
      formData.append("file", this.imagen);
      formData.append("data", JSON.stringify(this.form));
      this.subcategoriasService
        .createSubcategoria(formData)
        .then((result) => {
          if (result.data.status == 200) {
            this.form = {
              categoria_id: null,
              nombre: null,
              descripcion: null,
              disponible: 2,
            };
            this.imagen = null;
            this.$refs.imagen.reset();
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Registro creado satisfactoriamente",
            });
          } else {
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Error",
              variant: "danger",
              message: result.data.errores.join(" - "),
            });
          }
          this.inProcess = false;
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al guardar el registro",
          });
          this.inProcess = false;
        });
    },
    editRegister() {
      this.inProcess = true;
      let formData = new FormData();
      if (this.imagenTocada) {
        formData.append("file", this.imagen);
      }
      formData.append("data", JSON.stringify(this.form));
      this.subcategoriasService
        .editSubcategoria(formData)
        .then((result) => {
          if (result.data.status == 200) {
            this.form = {
              categoria_id: null,
              nombre: null,
              descripcion: null,
              disponible: 2,
            };
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Registro editado satisfactoriamente",
            });
            this.$router.push({ name: "SubcategoriasList" });
          } else {
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Error",
              variant: "danger",
              message: result.data.errores.join(" - "),
            });
          }
          this.inProcess = false;
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al editar el registro",
          });
          this.inProcess = false;
        });
    },
    onReset() {
      this.form = {
        categoria_id: null,
        nombre: null,
        descripcion: null,
        disponible: 2,
      };
      this.imagen = null;
      this.$refs.imagen.reset();
      this.$nextTick(() => {
        this.$refs.formAdd.reset();
      });
    },
    validation() {
      /* nombre */
      const validNombre = this.$refs.nombre.checkValidity();
      this.nombreState = validNombre;
      /* descripcion */
      const validDescripcion = this.$refs.descripcion.checkValidity();
      this.descripcionState = validDescripcion;
      /* imagen */
      let validImagen = true;
      if (this.type == "create" || (this.type == "edit" && this.imagenTocada)) {
        validImagen = this.$refs.imagen.isFileValid(this.imagen);
        this.imagenState = validImagen;
      }
      /*categorias*/
      const validCategoriasId = this.$refs.categoriaId.required
        ? this.$refs.categoriaId.value
          ? true
          : false
        : true;
      this.categoriaIdState = validCategoriasId;
      return (
        validNombre && validDescripcion && validImagen && validCategoriasId
      );
    },
  },
  watch: {
    $route(to) {
      to.params.id ? (this.type = "edit") : (this.type = "create");
      if (this.type == "edit") {
        this.recoveryDataRegister();
      }
    },
    imagen(newValue) {
      if (newValue) {
        if (newValue.size > 2048000) {
          this.$refs.imagen.reset();
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "warning",
            message: "El tamaño de la imagen no debe ser mayor a 2mb",
          });
          this.imagen = null;
        }
      }
      this.imagenTocada = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-cental {
  width: 100%;
  min-height: 700px;
  padding: 0px 300px;
}
@media (max-width: 1400px) {
  .container-cental {
    padding: 0px 10px;
  }
}
</style>
